import Debug from 'debug';

const debug = Debug('o365:version');

type VersionInfo = {
  appVersion: string;
  branchName: string;
  buildNumber: number;
  gitCommit: string;
};

const defaultVersion = {
  appVersion: '0.0.0.0',
  branchName: 'local',
  buildNumber: 0,
  gitCommit: '?',
};

export let version: VersionInfo = defaultVersion;
export let versionReady = false;

const versionPromise = (async function () {
  if (process.env.NODE_ENV === 'test') {
    versionReady = true;
    return defaultVersion;
  }

  let serverBase = '';
  const domainElement = document.querySelector('meta[name="domain"]') as HTMLMetaElement;
  if (domainElement) {
    serverBase = domainElement.content;
  } else {
    // hope for the best!
    serverBase = window.location.href;
  }

  debug('loadVersionInfo() start');
  let versionData: VersionInfo | null = null;
  try {
    const response = await fetch(new URL('/version', serverBase).toString(), {
      mode: 'cors',
      method: 'GET',
    });
    if (response.ok) {
      versionData = await response.json();
      debug('response ok', versionData);
    } else {
      debug('response not ok', response);
    }
  } catch (e) {
    // safely ignore errors
    debug('error fetching version', e);
  }

  version = versionData ?? defaultVersion;
  debug('using version info', version);

  versionReady = true;
  return version;
})();

export async function getAppVersion() {
  const { appVersion, branchName } = versionReady ? version : await versionPromise;

  let suffix = '';
  if (branchName === 'beta') {
    suffix = 'b';
  } else if (branchName !== 'master') {
    suffix = 'd';
  }

  return `${appVersion}${suffix}`;
}
